const prettySelectSelector = '.js-pretty-select',
  dataWrapperClassAttribute = 'data-wrapper-class',
  defaultWrapperClass = 'pretty-select-wrapper',
  hiddenClass = 'hidden',
  activeClass = 'active',
  cssBlock = 'styled-select',
  blockElementSeparator = '__',
  selectedTextIconWrapperClass = `${cssBlock}${blockElementSeparator}selected-text-icon-wrapper`,
  selectedTextClass = `${cssBlock}${blockElementSeparator}selected-text`,
  arrowIconWrapperClass = `${cssBlock}${blockElementSeparator}arrow-icon`,
  optionsDividerClass = `${cssBlock}${blockElementSeparator}options-divider`,
  optionsListClass = `${cssBlock}${blockElementSeparator}options-list`,
  wrapperElement = 'div',
  styledSelectElement = 'div',
  selectedTextElement = 'span',
  arrowIconWrapperElement = 'span',
  arrowIconSvgClass = 'icon-dropdown-arrow1',
  optionsDividerElement = 'div';

const prettySelect = async () => {
  const prettySelects = document.querySelectorAll(prettySelectSelector);

  [...prettySelects].forEach(select => {
    // Hide the select element
    select.classList.add(hiddenClass);

    // Wrap the select element in a div
    const wrapper = createWrapperElement(select);
    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);

    // Insert a styled div to sit over the top of the hidden select element
    const styledSelect = createStyledSelectElement();
    wrapper.appendChild(styledSelect);

    const selectedTextIconWrapper = createSelectedTextIconWrapper();
    styledSelect.appendChild(selectedTextIconWrapper);

    // Show the first select option in the styled div if the value is blank,
    // otherwise make a new blank option.
    const firstOption = select.options[0];
    if (firstOption) {
      const selectedText = createSelectedTextElement();
      selectedTextIconWrapper.appendChild(selectedText);

      if (
        typeof firstOption.getAttribute('value') === 'undefined' ||
        firstOption.getAttribute('value') === ''
      ) {
        selectedText.textContent = firstOption.textContent;
        select.removeChild(firstOption);
      }
    } else {
      // No options, so I guess we just remove it? Serves you right for
      // rendering the select with no options. The select is still in the DOM,
      // hidden for your debugging needs.
      styledSelect.parentElement.remove(styledSelect);
      return;
    }

    const arrowIconWrapper = createArrowIconElement();
    selectedTextIconWrapper.appendChild(arrowIconWrapper);

    const optionsDivider = createOptionsDividerElement();
    styledSelect.appendChild(optionsDivider);

    // Insert an unordered list after the styled div and also cache the list
    const optionsList = createOptionsListElement();
    styledSelect.appendChild(optionsList);

    // Insert a list item into the unordered list for each select option
    [...select.options].forEach(option => {
      const listItem = createListItemElement(option);
      optionsList.appendChild(listItem);
    });

    styledSelect.addEventListener('click', event => {
      event.stopPropagation();

      const activeSelects = document.querySelectorAll(
        `div.${cssBlock}.${activeClass}`
      );
      [...activeSelects].forEach(activeSelect => {
        if (activeSelect === styledSelect) return;

        activeSelect.classList.remove(activeClass);
      });

      if (styledSelect.classList.contains(activeClass)) {
        styledSelect.classList.remove(activeClass);
      } else {
        styledSelect.classList.add(activeClass);
      }
    });

    const listItems = optionsList.querySelectorAll('li');
    // Hides the unordered list when a list item is clicked and updates the
    // styled div to show the selected list item
    // Updates the select element to have the value of the equivalent option
    [...listItems].forEach(listItem => {
      listItem.addEventListener('click', event => {
        event.stopPropagation();
        const target = event.target;

        styledSelect.querySelector(`.${selectedTextClass}`).textContent =
          target.textContent;

        select.value = target.getAttribute('rel');
        const changeEvent = new Event('change');
        select.dispatchEvent(changeEvent);
        styledSelect.classList.remove(activeClass);
      });
    });

    // Hides the unordered list when clicking outside of it
    document.addEventListener('click', event => {
      let target = event.target;

      do {
        if (target === styledSelect) return;

        target = target.parentNode;
      } while (target);

      styledSelect.classList.remove(activeClass);
    });
  });
};

const createWrapperElement = select => {
  const wrapper = document.createElement(wrapperElement),
    wrapperClass =
      select.getAttribute(dataWrapperClassAttribute) || defaultWrapperClass;

  wrapper.classList.add(wrapperClass);

  return wrapper;
};

const createStyledSelectElement = () => {
  const styledSelect = document.createElement(styledSelectElement);
  styledSelect.classList.add(cssBlock);

  return styledSelect;
};

const createSelectedTextElement = () => {
  const selectedText = document.createElement(selectedTextElement);
  selectedText.classList.add(selectedTextClass);

  return selectedText;
};

const createArrowIconElement = () => {
  const arrowIconWrapper = document.createElement(arrowIconWrapperElement),
    arrowSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'),
    svgUse = document.createElementNS('http://www.w3.org/2000/svg', 'use');

  arrowIconWrapper.classList.add(arrowIconWrapperClass);

  arrowSvg.classList.add('icon');
  arrowSvg.classList.add(arrowIconSvgClass);

  svgUse.setAttribute('height', '20');
  svgUse.setAttribute('width', '20');
  svgUse.setAttributeNS(
    'http://www.w3.org/1999/xlink',
    'href',
    `#${arrowIconSvgClass}`
  );

  arrowSvg.appendChild(svgUse);
  arrowIconWrapper.appendChild(arrowSvg);

  return arrowIconWrapper;
};

const createOptionsDividerElement = () => {
  const optionsDivider = document.createElement(optionsDividerElement);
  optionsDivider.classList.add(optionsDividerClass);

  return optionsDivider;
};

const createOptionsListElement = () => {
  const optionsList = document.createElement('ul');
  optionsList.classList.add(optionsListClass);

  return optionsList;
};

const createListItemElement = option => {
  const listItem = document.createElement('li');
  listItem.textContent = option.textContent;
  listItem.setAttribute('rel', option.getAttribute('value'));

  return listItem;
};

const createSelectedTextIconWrapper = () => {
  const selectedTextIconWrapper = document.createElement('div');
  selectedTextIconWrapper.classList.add(selectedTextIconWrapperClass);

  return selectedTextIconWrapper;
};

export default {
  init: prettySelect,
};
